import * as React from 'react';
import { observer } from 'mobx-react';
import PlannedAbsenceIcon from '../../assets/icons/planned-absence.png';
import { Tooltip } from '@iba-team/portal-react-components/dist';
import { CellProps } from './EmptyCell';

export const PlannedCell = observer(({ event, selectedRange, setSelectedRange, currentMode, isYourCell, actionClassName, plannedCellClassName}: CellProps) => {

  const onClick = () => {
    setSelectedRange('DELETE');
  };

  const isFirstChild = selectedRange[0]?.startDate === event.startDate;

  const renderFirstChildBorder = () => {
    return `first-child-in-list-${currentMode?.toLowerCase()}`;
  };


  const renderTooltipTitle = () => {
    if (!isYourCell) {
      return 'Planned absence';
    }
    if (!selectedRange.length) {
      return 'Planned absence';
    }
    if (new Date(event.startDate) >= new Date(selectedRange[0]?.startDate)) {
      if (currentMode === 'ADD') {
        return 'Planned absence';
      }

      return (<div>Click to delete <br /> planned absence</div>);
    }

    return 'Planned absence';
  };

  const renderBackground = {background: !currentMode ? 'white' : ''};

  return(
    <div style={renderBackground} className={`default_cell_container ${actionClassName} ${plannedCellClassName} ${isFirstChild && renderFirstChildBorder()}`} onClick={onClick}>
      <div className={'drag_container'}>
        <Tooltip title={renderTooltipTitle()}>
          <img src={PlannedAbsenceIcon} alt={'plannedAbsence'}/>
        </Tooltip>
      </div>
    </div>
  );
});
